import DialogProvider from "..";
import UnifiedRegistry from "../..";
import { UnifiedRegistryProvider, withUnifiedRegistryStore } from "../../unified-registry-context";
import { getItemColor } from "../../utils";

import { Navigation } from "./Navigation";
import { useMoveToFolderModal } from "./hooks";
import { MoveToFolderDialogProps } from "./types";

import { EntityType, getEntityNumericId } from "@/queries";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { EntityIcon } from "@/components/ui/icons";

export const MoveToFolderDialog = withUnifiedRegistryStore(
  ({ open, entities, setOpen }: MoveToFolderDialogProps) => {
    const { selectedFolderId, handleSelectFolder, handleMove, currentFolder } =
      useMoveToFolderModal(entities, setOpen, open);

    return (
      <Dialog onOpenChange={setOpen} open={open}>
        <DialogContent className="flex h-full max-h-[720px] max-w-4xl flex-col gap-0 p-0">
          <DialogHeader className="border-b border-gray-200 px-6 py-4">
            {entities.length > 0 ? (
              <DialogTitle className="flex items-center gap-3 text-lg font-semibold text-gray-900">
                {entities.length === 1 && (
                  <div
                    className={`flex h-10 w-full max-w-[40px] flex-shrink-0 items-center justify-center rounded-full ${getItemColor(
                      entities[0].type,
                    )}`}
                  >
                    <EntityIcon type={entities[0].type} size="md" />
                  </div>
                )}
                <span className="min-w-0 flex-1">
                  Move{" "}
                  {entities.length === 1 ? `"${entities[0]?.name}"` : `${entities.length} items`}
                </span>
              </DialogTitle>
            ) : null}
          </DialogHeader>

          <UnifiedRegistryProvider
            options={{
              whitelist: [EntityType.FOLDER],
              disabled: entities,
              disableSelection: true,
              createInNewTab: true,
              modal: true,
            }}
          >
            <DialogProvider>
              <UnifiedRegistry
                currentFolderId={selectedFolderId}
                onItemClick={item => {
                  if (item.type === EntityType.FOLDER) {
                    const folderId = getEntityNumericId(item.id);
                    if (folderId !== undefined) {
                      handleSelectFolder(folderId);
                    }
                  }
                }}
              />
            </DialogProvider>
          </UnifiedRegistryProvider>

          <Navigation
            setOpen={setOpen}
            currentFolder={currentFolder}
            selectedFolderId={selectedFolderId}
            handleMove={handleMove}
            entityFolderIds={[...entities.map(entity => entity?.folder_id ?? null)]}
          />
        </DialogContent>
      </Dialog>
    );
  },
);
